import { WebAuth } from 'auth0-js';

let webAuth: WebAuth;

const getWebAuth = () => {
  if (!webAuth) {
    if (
      typeof window !== 'undefined' &&
      // the window.config values we require will not be present on pw reset route
      window.location.pathname === '/login'
    ) {
      const redirectUri = window.config.callbackURL;

      webAuth = new WebAuth({
        domain: window.config.auth0Domain,
        clientID: window.config.clientID,
        redirectUri,
        tenant: window.config.auth0Tenant,
        responseType: 'code',
        leeway: 60,
        ...window.config.internalOptions,
        overrides: {
          __tenant: window.config.auth0Tenant,
        },
      });
    }
  }

  return webAuth;
};

export default getWebAuth;
